import { render } from "./DebriyajGuclendiricisi.vue?vue&type=template&id=8cee4d28"
import script from "./DebriyajGuclendiricisi.vue?vue&type=script&lang=js"
export * from "./DebriyajGuclendiricisi.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\ulas\\Desktop\\projeler\\eku\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__